import { useAxiosPrivate } from "./axios";

const LIST_QUERY = "/app/list";
const DELETE_QUERY = "/app/delete";
const REGISTRATE_NEW_QUERY = "app/create";

export const useSearchApps = () => {
  const searchApps = async (params, callback) => {
    const searchParam = {
      offset: params.offset,
      limit: params.limit,
      deleted: false,
    };

    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        params: searchParam,
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return searchApps;
};

export const useDeleteAppByKey = () => {
  const deleteAppByKey = async (appKey, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.delete(DELETE_QUERY, {
        data: { key: appKey },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return deleteAppByKey;
};

export const useRegistrateApp = () => {
  const createTemplate = async (userId, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.post(
        REGISTRATE_NEW_QUERY,
        { appUserId: userId },
        {
          signal: controller.signal,
        },
      );
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return createTemplate;
};
